import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_is_a_factor_in_decisions_on_termination'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_is_a_factor_in_decisions_on_termination',
  name: 'Which of the following is a factor in decisions on termination, forced resignation, retrenchment or retirement?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RACE_ETHNIC_GROUP_SKIN_COLOR',
      text: 'Race / Ethnic Group / Skin Color',
      externalIds: [
        {
          id: 'disc-11--1',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SEX_GENDER',
      text: 'Sex / Gender',
      externalIds: [
        {
          id: 'disc-11--2',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RELIGION',
      text: 'Religion',
      externalIds: [
        {
          id: 'disc-11--3',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'POLITICAL_OPINION',
      text: 'Political Opinion',
      externalIds: [
        {
          id: 'disc-11--4',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NATIONAL_EXTRACTION',
      text: 'National Extraction',
      externalIds: [
        {
          id: 'disc-11--5',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SOCIAL_ORIGIN',
      text: 'Social Origin',
      externalIds: [
        {
          id: 'disc-11--6',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISABILITY',
      text: 'Disability',
      externalIds: [
        {
          id: 'disc-11--7',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
      text: 'HIV / AIDS Status (real or perceived)',
      externalIds: [
        {
          id: 'disc-11--8',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SEXUAL_ORIENTATION',
      text: 'Sexual Orientation',
      externalIds: [
        {
          id: 'disc-11--9',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PREGNANCY_MATERNITY_STATUS',
      text: 'Pregnancy / Maternity Status',
      externalIds: [
        {
          id: 'disc-11--10',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MARITAL_STATUS',
      text: 'Marital Status',
      externalIds: [
        {
          id: 'disc-11--11',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'AGE',
      text: 'Age',
      externalIds: [
        {
          id: 'disc-11--12',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
      text: 'Nationality / Foreign Migrant Worker Status',
      externalIds: [
        {
          id: 'disc-11--13',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FAMILY_RESPONSIBILITIES',
      text: 'Family responsibilities',
      externalIds: [
        {
          id: 'ter-dis-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'disc-11--14',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe what "Other" factor is considered in decisions regarding termination, forced resignation, retrenchment or retirement:',
        externalIds: [
          {
            id: 'disc-11--14-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RACE_ETHNIC_GROUP_SKIN_COLOR',
                'SEX_GENDER',
                'RELIGION',
                'POLITICAL_OPINION',
                'NATIONAL_EXTRACTION',
                'SOCIAL_ORIGIN',
                'DISABILITY',
                'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
                'SEXUAL_ORIENTATION',
                'PREGNANCY_MATERNITY_STATUS',
                'MARITAL_STATUS',
                'AGE',
                'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
                'FAMILY_RESPONSIBILITIES',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-11',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17930,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
